import Main from '@/views/layouts/main/index'
import ErrorLimit from '@/views/components/error-limit/index.component'
import { HomeModule } from '@/views/home'

const Home = () => {
  return (
    <Main>
      <ErrorLimit>
        <HomeModule />
      </ErrorLimit>
    </Main>
  )
}

export default Home
